const IconButton = {
  defaultProps: {},
  styleOverrides: {
    root: ({ theme }) => ({
      color: theme.palette.common.white,
    }),
  },
};

export default IconButton;
